import { userService } from "@/_services";

export const users = {
  namespaced: true,
  state: {
    all: {},
    profile: null
  },
  getters: {
    getProfile(state) {
      return state.profile;
    },
  },
  mutations: {
    setProfile(state, profile) {
      state.profile = profile;
    },
    getAllRequest(state) {
      state.all = { loading: true };
    },
    getAllSuccess(state, users) {
      state.all = { items: users };
    },
    getAllFailure(state, error) {
      state.all = { error };
    }
  },
  actions: {
    async getConsom(context) {
      let consom = await userService.consom();
      return consom.data;
    },
    getAll({ commit }) {
      commit("getAllRequest");

      userService.getAll().then(
        users => {
          commit("getAllSuccess", users);
        },
        error => {
          
          commit("getAllFailure", error);
        }
      );
    },
    getProfile: (context, data) => new Promise((res, rej) => {
      userService.getProfile(data)
      .then(response => { 
        let profile = response.data.results[0];
        context.commit('setProfile', profile)
        res(profile)
      })
      .catch(err => {rej(err)});
    }),
    updateProfil: (context, datas) => new Promise((res, rej) => {
      userService.updateProfil(datas)
      .then((resp) => res(resp.data))
      .catch((err) => rej(err));
    }),
    getUser: (context, data) => new Promise((res, rej) => {
      userService.getUser(data)
      .then(response => { res(response.data)})
      .catch(err => {rej(err)});
    }),
    updateUser: (context, datas) => new Promise((res, rej) => {
      userService.updateUser(datas)
      .then((resp) => res(resp.data))
      .catch((err) => rej(err));
    }),
  }
};
